import { extend } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';

// Utility function to capitalize the first letter of field names
const capitalize = (fieldName) => {
    return fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
};

// These extensions are for generic error messages to common validations
// If you need a more specific error message, please create a custom
// validation inside the component you're using it for.
extend('email', {
    ...email,
    message: 'Invalid email',
});

extend('required', {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1,
        };
    },
    computesRequired: true,
    message: (fieldName) => {
        fieldName = fieldName
            .split('')
            .map((letter, i) => {
                if (i !== 0) {
                    return letter;
                }

                return letter.toUpperCase();
            })
            .join('');

        return `${fieldName} is required`;
    },
});

// Phone number validation with country code(without +)
extend('mobile', {
    validate(value) {
        if (!value || value.trim() === '') {
            return true; // Skip validation if empty
        }

        const digitsOnly = value.replace(/\D/g, '');

        // Must be 11–15 digits and not start with 0
        return /^[1-9]\d{10,14}$/.test(digitsOnly);
    },

    message: (fieldName) =>
        `${capitalize(fieldName)} must be a valid mobile number with country code (without +), e.g., 12025550123`,
});

// Phone number validation
extend('phone', {
    validate(value) {
        if (!value || value.trim() === '') {
            return true; // Skip validation if empty
        }

        const digitsOnly = value.replace(/\D/g, '');

        // If value starts with "+", allow country code + 10-digit number
        if (value.trim().startsWith('+')) {
            return digitsOnly.length > 10 && digitsOnly.length <= 15;
        }

        // If no country code, ensure it's exactly 10 digits
        return digitsOnly.length === 10;
    },
    message: (fieldName) => `${capitalize(fieldName)} must be a valid phone number (10 digits)`,
});

// Integer validation
extend('integer', {
    validate(value) {
        const regex = /^[0-9]*$/;
        return String(value).match(regex);
    },
    message: `Only positive integer allowed`,
});

// Allow up 1 decimal place
extend('OneDecimalPlace', {
    validate(value) {
        const regex = /^\d+(\.\d{1})?$/;
        return String(value).match(regex);
    },
    message: `Allowed numbers upto 1 decimal place only`,
});

// Three words separated by two dots
extend('ThreeWordsSeparationByTwo', {
    validate(value) {
        const regex = /^[a-zA-Z]+\.[a-zA-Z]+\.[a-zA-Z]+$/;
        return String(value).match(regex);
    },
    message: (fieldName) => `Please enter valid ID for eg: us.zoom.videomeeting`,
});

// Four words separated by three dots
extend('FourWordsSeparationByThree', {
    validate(value) {
        const regex = /^[a-zA-Z]+\.[a-zA-Z]+\.[a-zA-Z]+\.[a-zA-Z]+$/;
        return String(value).match(regex);
    },
    message: (fieldName) => `Please enter valid ID for eg: us.zoom.video.meeting`,
});

// Validate urls
extend('ValidateUrl', {
    validate(value) {
        const regex =
            '((http|https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)';
        return String(value).match(regex);
    },
    message: `Invalid link. (example: https://www.abc.com)`,
});
